var map = {
	"./tech-responsive-apache-airflow.svg": 613,
	"./tech-responsive-artificial-intelligence.svg": 546,
	"./tech-responsive-azure.svg": 614,
	"./tech-responsive-chatgpt.svg": 615,
	"./tech-responsive-copilot.svg": 616,
	"./tech-responsive-data.svg": 617,
	"./tech-responsive-excel.svg": 618,
	"./tech-responsive-git.svg": 619,
	"./tech-responsive-google-cloud.svg": 620,
	"./tech-responsive-google-sheets.svg": 621,
	"./tech-responsive-hugging-face.svg": 622,
	"./tech-responsive-jupyter.svg": 623,
	"./tech-responsive-langchain.svg": 624,
	"./tech-responsive-llama.svg": 625,
	"./tech-responsive-multiple.svg": 626,
	"./tech-responsive-powerbi.svg": 627,
	"./tech-responsive-powerpoint.svg": 628,
	"./tech-responsive-python.svg": 629,
	"./tech-responsive-r.svg": 630,
	"./tech-responsive-shell.svg": 631,
	"./tech-responsive-sql.svg": 632,
	"./tech-responsive-tableau.svg": 633,
	"./tech-responsive-theory.svg": 634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 524;